import { NotificationResponse } from "@cnx/common";
import { Box, Flex, Text, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import NotificationCard from "../NotificationCard";

interface NotificationProps {
  data: NotificationResponse;
}

const Notifications: React.FC<NotificationProps> = ({ data }) => {
  const { t } = useTranslation("notifications");

  const { newNotifications, readNotifications } = data;

  return (
    <>
      <Flex
        align={"center"}
        justify={"space-between"}
        direction={"column"}
        px={14}
        py={10}
        gap={"md"}
        className="w-full bg-white border-b border-gray-light"
      >
        <Flex gap={"sm"} className="flex-col w-full gap-2">
          <TextInput
            data-testid="search-input"
            className="grow"
            placeholder={t("search")}
            rightSection={<IconSearch size={16} className="text-gray-7" />}
          />
        </Flex>
      </Flex>
      {newNotifications.length !== 0 && (
        <>
          <Box py={5}>
            <Text fz={14} fw={600} ml={28}>
              {t("new")}
            </Text>
          </Box>
          <ul className={"border-b border-gray-light"}>
            {newNotifications?.map(notification => (
              <li
                className={"border-t border-gray-light"}
                key={notification.id}
              >
                <NotificationCard notification={notification} />
              </li>
            ))}
          </ul>
        </>
      )}

      {readNotifications?.length !== 0 && (
        <>
          <Box py={5}>
            <Text fz={14} fw={600} ml={28}>
              {t("read")}
            </Text>
          </Box>
          <ul className={"border-b opacity-50 bg-[#f0f0f0] border-gray-light"}>
            {readNotifications?.map(notification => (
              <li
                className={"border-t border-gray-light"}
                key={notification.id}
              >
                <NotificationCard notification={notification} />
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default Notifications;
